import { createAsyncThunk } from '@reduxjs/toolkit';

export const LoadMarketplaceTemplatePricing = createAsyncThunk(
    'marketplace/template/pricing/loadPricing',
    async (_, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const response = await axios.get(`api/marketplace/pricing`);
        return response;
    }
);

export const LoadMarketplacePricing = createAsyncThunk(
    'marketplace/pricing/loadPricing',
    async (engagmentId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const response = await axios.get(`api/marketplace/pricing/${engagmentId}`);
        return response;
    }
);
